import Pusher from 'pusher-js';
import CONFIG from 'shared/config';
import pusherAuthService from 'shared/clients/pusher/pusherAuthService.js';

export const createPusher = (options) => {
  // PUSHER_HOST set → Soketi locally (cluster ignored). Unset → cloud.
  const localHostOverride = CONFIG.PUSHER_HOST
    ? {
        wsHost: CONFIG.PUSHER_HOST,
        wsPort: CONFIG.PUSHER_PORT,
        wssPort: CONFIG.PUSHER_PORT,
        forceTLS: CONFIG.PUSHER_FORCE_TLS,
        enabledTransports: ['ws', 'wss'],
      }
    : { forceTLS: true };

  return new Pusher(CONFIG.PUSHER_APP_KEY, {
    cluster: CONFIG.PUSHER_CLUSTER,
    authorizer: (channel) => ({
      authorize: async (socketId, callback) => {
        try {
          const response = await pusherAuthService.create({
            channel_name: channel.name,
            socket_id: socketId,
          });
          callback(false, response);
        } catch (e) {
          callback(true);
        }
      },
    }),
    ...localHostOverride,
    ...options,
  });
};
